// NaturalEnhanceFilter.jsx
import React from 'react';
import { FILTER_PRESETS } from 'constants/filters';
import FilterPresetButton from './FilterPresetButton';

export default function NaturalEnhanceFilter() {
  return (
    <FilterPresetButton
      presetKey={FILTER_PRESETS.NATURAL_ENHANCE}
      label="Natural"
      image="natural"
      thumbnailClassName="bg-gradient-to-br from-neutral-200 via-neutral-100 to-neutral-300"
      showRecommended
    />
  );
}
